import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
Copyright 2022 The Matrix.org Foundation C.I.C.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

/**
 * Common interface for the crypto implementations
 *
 * @internal
 */

/** The methods which crypto implementations should expose to the Sync api
 *
 * @internal
 */

/**
 * @internal
 */

/**
 * The result of a (successful) call to {@link CryptoBackend.decryptEvent}
 */

/**
 * Responsible for decrypting megolm session data retrieved from a remote backup.
 * The result of {@link CryptoBackend#getBackupDecryptor}.
 */

/**
 * Exception thrown when decryption fails
 *
 * @param code - Reason code for the failure.
 *
 * @param msg - user-visible message describing the problem
 *
 * @param details - key/value pairs reported in the logs but not shown
 *   to the user.
 */
export class DecryptionError extends Error {
  constructor(code, msg, details) {
    super(msg);
    _defineProperty(this, "detailedString", void 0);
    this.code = code;
    this.name = "DecryptionError";
    this.detailedString = detailedStringForDecryptionError(this, details);
  }
}
function detailedStringForDecryptionError(err, details) {
  let result = err.name + "[msg: " + err.message;
  if (details) {
    result += ", " + Object.keys(details).map(k => k + ": " + details[k]).join(", ");
  }
  result += "]";
  return result;
}
//# sourceMappingURL=CryptoBackend.js.map